import React, { useEffect, useContext } from "react";
import { diaMes, diasaHoy, L4SEMANAS, LPROY, LINI, DIASMES, colores, clBasic, bkSubMain } from "./general";
import { useHistory } from "react-router-dom";
import { AppContext } from "./index";

export default function Planproyecto({ proyecto, i, iniciomenor, finmayor }) {
  let history = useHistory();
  let { firebase } = useContext(AppContext);
  let color = colores["semaforo"];

  const l4semanas = (fp) => {
    // largo en pixeles del tramo del proyecto de 4 semanas desde el dia de la fecha
    return diasaHoy(fp) > DIASMES ? L4SEMANAS - LINI : diasaHoy(fp) > 0 ? (diasaHoy(fp) * (L4SEMANAS - LINI)) / DIASMES : 0;
  };

  const hitoDelMes = (f) => {
    return diasaHoy(f) <= DIASMES && diasaHoy(f) >= 0;
  };

  const hitoTramoInicial = (f) => {
    return diasaHoy(f) < 0;
  };

  const xHito = (f, ft) => {
    // devuelve coord X corresp. al hito, considerando si esta dentro de las 4 semanas, en tramo inicial o en tramo final
    let xPure = hitoDelMes(f)
      ? LINI + (diasaHoy(f) * (L4SEMANAS - LINI)) / DIASMES
      : hitoTramoInicial(f)
        ? LINI - (-diasaHoy(f) * LINI) / -diasaHoy(ft)
        : L4SEMANAS + (diasaHoy(f) * (LPROY - L4SEMANAS)) / diasaHoy(ft);
    return xPure === 0 ? xPure + 15 : xPure;
  };

  function setCanvas(fp, ftp, ip, itp, lact) {
    // inicializacion de datos para el canvas del proyecto
    var c = document.getElementById(`proyecto${i}`);
    var ctx = c.getContext("2d");
    // tramo 4 semanas
    ctx.beginPath();
    ctx.setLineDash([]);
    ctx.lineWidth = 24;
    ctx.moveTo(hitoDelMes(ip) ? xHito(ip, ftp) : LINI, 75);
    ctx.lineTo(LINI + l4semanas(fp), 75);
    ctx.strokeStyle = color[proyecto.estado.semaforo];
    ctx.stroke();
    ctx.closePath();

    if (diasaHoy(ip) < 0) {
      // tramo inicial del proyecto hasta la fecha del dia,  si su fecha de inicio es antaerior a fecha del dia
      ctx.beginPath();
      ctx.setLineDash([3, 3]);
      ctx.lineWidth = 4;
      ctx.moveTo(xHito(ip, itp), 85);
      //ctx.lineTo(xHito(fp, fp), 85);
      ctx.lineTo(LINI, 85);
      ctx.stroke();
      ctx.closePath();
    }
    // tramo final del proyecto si su fecha de fin es posterior a 4 semanas desde fecha del dia
    if (diasaHoy(fp) > DIASMES) {
      ctx.beginPath();
      ctx.lineWidth = 4;
      ctx.setLineDash([3, 3]);
      ctx.moveTo(L4SEMANAS, 65);
      ctx.lineTo(xHito(fp, ftp), 65);
      ctx.stroke();
      ctx.closePath();
    }

    // primer hito
    drawStar(ctx, xHito(ip, itp), 70, 3, diaMes(ip, 1), "", "primero"); //diaMes(ip, 1)

    // hitos 4 semanas
    for (let j = 0; j < lact.length; j++) {
      // itero hasta el penultimo inclusive
      if (hitoDelMes(lact[j].finEstimado) && lact[j].finEstimado !== fp) {
        drawStar(ctx, xHito(lact[j].finEstimado, ftp), 65, 7, diaMes(lact[j].finEstimado, 1), lact[j].nombre, "medios");
      }
    }

    // ultimo hito
    drawStar(ctx, xHito(fp, ftp), 70, 3, diaMes(fp, 1), "", "ultimo"); //diaMes(fp, 1)
  }

  function drawStar(ctx, x, y, a, fecha, actividad, hito) {
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x - a, y + a);
    ctx.lineTo(x - 2 * a, y + 1.5 * a);
    ctx.lineTo(x - a, y + 2 * a);
    ctx.lineTo(x, y + 3 * a);
    ctx.lineTo(x + a, y + 2 * a);
    ctx.lineTo(x + 2 * a, y + 1.5 * a);
    ctx.lineTo(x + a, y + a);
    ctx.closePath();
    ctx.fillStyle = clBasic;
    ctx.fill();

    ctx.fillStyle = clBasic;
    ctx.font = "12px Arial";
    ctx.fillText(actividad, x - 30, 45);
    ctx.font = hito === "medios" ? "15px Arial" : "12px Arial";
    ctx.fillText(fecha, hito === "medios" ? x - 17 : x, hito === "medios" ? 60 : 97);
  }

  useEffect(() => {
    let a = [...firebase.actividades(proyecto.id)];
    let { fmenor, fmayor } = firebase.marcoFechas(a);
    setCanvas(fmayor, finmayor, fmenor, iniciomenor, a);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={Sproyecto}
      onClick={() => {
        firebase.activarProyecto(proyecto);
        history.push("/AdminProyecto");
      }}
    >
      <div style={ScanvasProyecto}>
        <div
          style={SnomYfoto}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "")}
        >
          <img src={firebase.usuario(proyecto.pm).url} height="50px" width="50px" alt="?" style={Sfoto} />
          <div style={Snombre}>{proyecto.nombre} </div>
        </div>
        <canvas id={`proyecto${i}`} width={`${LPROY + 50}px`}></canvas>
      </div>
    </div>
  );
}

const Sproyecto = {
  height: "120px",
  cursor: "pointer",
  marginBottom: "10px",
  background: "#e6e6e6",
  borderRadius: "15px"
};

const ScanvasProyecto = {
  display: "flex",
  flexDirection: "row",
  margin: "0px 20px 0px 20px",
};

const SnomYfoto = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
  borderRadius: "5px",
  width: "290px",
  margin: "10px 10px 45px 0px",
  background: bkSubMain
};

const Snombre = {
  width: "230px",
  font: "700 2vh Arial",
  color: clBasic,
  margin: "25px 0px 0px 10px",
};

const Sfoto = {
  clipPath: "circle(50%)",
  margin: "20px 0px 0px 10px"
};
